export const NEW_GROUP_ID = -1;
export const GROUP_ELEMENT_ID_PREFIX = 'jsd-portal-group';

export const NO_PRACTICE = 'no-practice' as const;
export const UNASSIGNED_REQUEST_TYPE = 'unassigned_request_type' as const;

export const ERROR_STATE_REVERT_PATH = 'response.stateReverted';

export const REMOVE_GROUP_GUARDS = {
	userConfirmation: 'userConfirmation',
	oneTicketTypeLeft: 'oneTicketTypeLeft',
	orphanTicketTypes: 'orphanTicketTypes',
} as const;

export const REQUEST_GROUP_NOT_FOUND_ERROR = 'sd.internal.requestype.group.error.not-found';
export const REQUEST_GROUP_DUPLICATE_NAME_ERROR =
	'sd.admin.request.groups.add.name.duplicate.error';
export const REQUEST_GROUP_NAME_TOO_LONG_ERROR = 'sd.admin.request.groups.add.name.too.long.error';
export const REQUEST_GROUP_NAME_REQUIRED_ERROR = 'sd.admin.request.groups.add.name.required.error';
export const REQUEST_TYPE_NOT_FOUND_ERROR = 'sd.customerview.error.requestTypeNotFound';
export const REQUEST_TYPE_INVALID_ERROR = 'sd.error.issuetype.not.associated';
